import { supabase } from './supabase'

export const MIGRATIONS = [
  // v2: Client intake fields
  { table: 'clients', column: 'entry_type', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS entry_type TEXT DEFAULT 'phone'" },
  { table: 'clients', column: 'origin_address', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS origin_address TEXT DEFAULT ''" },
  { table: 'clients', column: 'destination_address', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS destination_address TEXT DEFAULT ''" },
  { table: 'clients', column: 'additional_stops', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS additional_stops TEXT DEFAULT ''" },
  { table: 'clients', column: 'move_date', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS move_date DATE" },
  { table: 'clients', column: 'walkthrough_date', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS walkthrough_date DATE" },
  { table: 'clients', column: 'job_type', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS job_type TEXT DEFAULT 'LOCAL'" },
  { table: 'clients', column: 'packing_needed', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS packing_needed TEXT DEFAULT 'none'" },
  { table: 'clients', column: 'heavy_items', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS heavy_items TEXT DEFAULT ''" },
  { table: 'clients', column: 'from_sqft', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS from_sqft INTEGER DEFAULT 0" },
  { table: 'clients', column: 'from_levels', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS from_levels INTEGER DEFAULT 1" },
  { table: 'clients', column: 'from_stairs', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS from_stairs BOOLEAN DEFAULT false" },
  { table: 'clients', column: 'from_elevator', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS from_elevator BOOLEAN DEFAULT false" },
  { table: 'clients', column: 'from_driveway', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS from_driveway TEXT DEFAULT ''" },
  { table: 'clients', column: 'from_walk_distance', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS from_walk_distance TEXT DEFAULT ''" },
  { table: 'clients', column: 'to_sqft', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS to_sqft INTEGER DEFAULT 0" },
  { table: 'clients', column: 'to_levels', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS to_levels INTEGER DEFAULT 1" },
  { table: 'clients', column: 'to_stairs', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS to_stairs BOOLEAN DEFAULT false" },
  { table: 'clients', column: 'to_elevator', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS to_elevator BOOLEAN DEFAULT false" },
  { table: 'clients', column: 'to_driveway', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS to_driveway TEXT DEFAULT ''" },
  { table: 'clients', column: 'to_walk_distance', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS to_walk_distance TEXT DEFAULT ''" },
  { table: 'clients', column: 'referral_name', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS referral_name TEXT DEFAULT ''" },
  { table: 'clients', column: 'sms_approved', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS sms_approved BOOLEAN DEFAULT false" },
  { table: 'clients', column: 'description', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS description TEXT DEFAULT ''" },
  // v3: Crew skill levels
  { table: 'crew_members', column: 'skill_level', sql: "ALTER TABLE crew_members ADD COLUMN IF NOT EXISTS skill_level INTEGER DEFAULT 1" },
  // v4: Internal notes + multi-skill system
  { table: 'clients', column: 'internal_notes', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS internal_notes TEXT DEFAULT ''" },
  { table: 'clients', column: 'crew_size_needed', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS crew_size_needed INTEGER DEFAULT 0" },
  { table: 'clients', column: 'trucks_needed', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS trucks_needed TEXT DEFAULT ''" },
  { table: 'crew_members', column: 'skill_moving', sql: "ALTER TABLE crew_members ADD COLUMN IF NOT EXISTS skill_moving INTEGER DEFAULT 0" },
  { table: 'crew_members', column: 'skill_packing', sql: "ALTER TABLE crew_members ADD COLUMN IF NOT EXISTS skill_packing INTEGER DEFAULT 0" },
  // v5: Estimates integration
  { table: 'photos', column: 'estimate_id', sql: "ALTER TABLE photos ADD COLUMN IF NOT EXISTS estimate_id UUID" },
  { table: 'move_jobs', column: 'estimate_id', sql: "ALTER TABLE move_jobs ADD COLUMN IF NOT EXISTS estimate_id UUID" },
  // v6: User profile password tracking
  { table: 'user_profiles', column: 'password_set', sql: "ALTER TABLE user_profiles ADD COLUMN IF NOT EXISTS password_set BOOLEAN DEFAULT true" },
  // v7: Photo batches
  { table: 'photos', column: 'upload_batch_id', sql: "ALTER TABLE photos ADD COLUMN IF NOT EXISTS upload_batch_id TEXT" },
  { table: 'photos', column: 'batch_label', sql: "ALTER TABLE photos ADD COLUMN IF NOT EXISTS batch_label TEXT DEFAULT ''" },
  // v7: Virtual walkthrough + apartment fields
  { table: 'clients', column: 'virtual_walkthrough', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS virtual_walkthrough BOOLEAN DEFAULT false" },
  { table: 'clients', column: 'from_apartment', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS from_apartment BOOLEAN DEFAULT false" },
  { table: 'clients', column: 'from_apartment_floor', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS from_apartment_floor TEXT DEFAULT ''" },
  { table: 'clients', column: 'to_apartment', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS to_apartment BOOLEAN DEFAULT false" },
  { table: 'clients', column: 'to_apartment_floor', sql: "ALTER TABLE clients ADD COLUMN IF NOT EXISTS to_apartment_floor TEXT DEFAULT ''" },
]

// Estimates table — created once if it doesn't exist
export const ESTIMATES_TABLE_SQL = `
CREATE TABLE IF NOT EXISTS estimates (
  id UUID DEFAULT gen_random_uuid() PRIMARY KEY,
  client_id UUID REFERENCES clients(id) ON DELETE CASCADE,
  job_number TEXT UNIQUE NOT NULL,
  status TEXT DEFAULT 'building',
  origin_address TEXT DEFAULT '',
  destination_address TEXT DEFAULT '',
  additional_stops TEXT DEFAULT '',
  move_date DATE,
  walkthrough_date DATE,
  job_type TEXT DEFAULT 'LOCAL',
  packing_needed TEXT DEFAULT 'none',
  heavy_items TEXT DEFAULT '',
  from_sqft INTEGER DEFAULT 0,
  from_levels INTEGER DEFAULT 1,
  from_stairs BOOLEAN DEFAULT false,
  from_elevator BOOLEAN DEFAULT false,
  from_driveway TEXT DEFAULT '',
  from_walk_distance TEXT DEFAULT '',
  to_sqft INTEGER DEFAULT 0,
  to_levels INTEGER DEFAULT 1,
  to_stairs BOOLEAN DEFAULT false,
  to_elevator BOOLEAN DEFAULT false,
  to_driveway TEXT DEFAULT '',
  to_walk_distance TEXT DEFAULT '',
  crew_size_needed INTEGER DEFAULT 0,
  travel_crew_size INTEGER DEFAULT 0,
  trucks_needed TEXT DEFAULT '',
  estimated_hours NUMERIC(5,2) DEFAULT 0,
  hourly_rate NUMERIC(8,2) DEFAULT 0,
  travel_fee NUMERIC(8,2) DEFAULT 0,
  materials_fee NUMERIC(8,2) DEFAULT 0,
  hold_fee NUMERIC(8,2) DEFAULT 0,
  bol_deposit NUMERIC(10,2) DEFAULT 0,
  bol_deposit_status TEXT CHECK (bol_deposit_status IS NULL OR bol_deposit_status IN ('requested','collected')),
  bol_deposit_collected_by TEXT,
  bol_deposit_method TEXT CHECK (bol_deposit_method IS NULL OR bol_deposit_method IN ('cash','card','check','zelle','other')),
  bol_deposit_collected_at TIMESTAMPTZ,
  total_estimate NUMERIC(10,2) DEFAULT 0,
  description TEXT DEFAULT '',
  internal_notes TEXT DEFAULT '',
  created_at TIMESTAMPTZ DEFAULT now(),
  updated_at TIMESTAMPTZ DEFAULT now()
);
CREATE INDEX IF NOT EXISTS idx_estimates_client_id ON estimates(client_id);
CREATE INDEX IF NOT EXISTS idx_estimates_status ON estimates(status);
CREATE INDEX IF NOT EXISTS idx_estimates_job_number ON estimates(job_number);
CREATE INDEX IF NOT EXISTS idx_estimates_move_date ON estimates(move_date);
`

export async function runMigrations() {
  try {
    // Check which columns exist by fetching one row from each table
    const { data: clientSample } = await supabase.from('clients').select('*').limit(1)
    const { data: crewSample } = await supabase.from('crew_members').select('*').limit(1)
    const photoRes = await supabase.from('photos').select('*').limit(1)
    const photoSample = photoRes.data
    const jobRes = await supabase.from('move_jobs').select('*').limit(1)
    const jobSample = jobRes.data
    const clientCols = clientSample && clientSample.length > 0 ? Object.keys(clientSample[0]) : []
    const crewCols = crewSample && crewSample.length > 0 ? Object.keys(crewSample[0]) : []
    const photoCols = photoSample && photoSample.length > 0 ? Object.keys(photoSample[0]) : []
    const jobCols = jobSample && jobSample.length > 0 ? Object.keys(jobSample[0]) : []

    const knownColsByTable = {
      clients: new Set(clientCols),
      crew_members: new Set(crewCols),
      photos: new Set(photoCols),
      move_jobs: new Set(jobCols),
    }

    let ran = 0
    for (const m of MIGRATIONS) {
      // Only attempt migrations for tables we introspect above —
      // user_profiles isn't probed, so its password_set entry fired the
      // exec_sql RPC on EVERY load and logged "Could not find the function
      // public.exec_sql" forever (QA M4 OBS-10). Real schema changes ship
      // via sql/ files now; this runtime path is legacy.
      if (!(m.table in knownColsByTable)) continue
      const tableKnown = knownColsByTable[m.table] || new Set()
      if (!tableKnown.has(m.column)) {
        const { error } = await supabase.rpc('exec_sql', { query: m.sql }).maybeSingle()
        if (error) {
          // exec_sql not existing is the NORMAL prod state — stay quiet
          // for that; only surface unexpected failures.
          if (!/could not find the function/i.test(error.message || '')) {
            console.log(`Migration note (${m.column}):`, error.message)
          }
        } else {
          ran++
        }
      }
    }
    if (ran > 0) console.log(`Ran ${ran} migrations`)

    // Create estimates table if it doesn't exist
    const { error: estErr } = await supabase.from('estimates').select('id').limit(1)
    if (estErr && estErr.code === '42P01') {
      // Table doesn't exist — create it
      const { error: createErr } = await supabase.rpc('exec_sql', { query: ESTIMATES_TABLE_SQL }).maybeSingle()
      if (createErr) {
        console.log('Estimates table creation note:', createErr.message)
      } else {
        console.log('Created estimates table')
      }
    }

    // Create user_profiles table if it doesn't exist
    const { error: profileErr } = await supabase.from('user_profiles').select('id').limit(1)
    if (profileErr && profileErr.code === '42P01') {
      const USER_PROFILES_SQL = `CREATE TABLE IF NOT EXISTS user_profiles (id UUID DEFAULT gen_random_uuid() PRIMARY KEY, user_id UUID REFERENCES auth.users(id) ON DELETE CASCADE UNIQUE, email TEXT NOT NULL DEFAULT '', display_name TEXT DEFAULT '', role TEXT NOT NULL DEFAULT 'office' CHECK (role IN ('admin', 'office')), created_at TIMESTAMPTZ DEFAULT NOW()); ALTER TABLE user_profiles ENABLE ROW LEVEL SECURITY; CREATE POLICY "Authenticated users can view profiles" ON user_profiles FOR SELECT TO authenticated USING (true); CREATE POLICY "Users can update own profile" ON user_profiles FOR UPDATE TO authenticated USING (auth.uid() = user_id); CREATE POLICY "Authenticated users can insert profiles" ON user_profiles FOR INSERT TO authenticated WITH CHECK (true); CREATE POLICY "Authenticated users can delete profiles" ON user_profiles FOR DELETE TO authenticated USING (true);`
      const { error: createErr } = await supabase.rpc('exec_sql', { query: USER_PROFILES_SQL }).maybeSingle()
      if (createErr) {
        console.log('user_profiles table creation note:', createErr.message)
      } else {
        console.log('Created user_profiles table')
      }
    }

    // Create user_invites table if it doesn't exist
    const { error: invErr } = await supabase.from('user_invites').select('id').limit(1)
    if (invErr && invErr.code === '42P01') {
      const USER_INVITES_SQL = `CREATE TABLE IF NOT EXISTS user_invites (id UUID DEFAULT gen_random_uuid() PRIMARY KEY, email TEXT NOT NULL UNIQUE, display_name TEXT DEFAULT '', role TEXT NOT NULL DEFAULT 'office' CHECK (role IN ('admin', 'office')), status TEXT NOT NULL DEFAULT 'pending' CHECK (status IN ('pending', 'accepted', 'expired')), invited_by UUID REFERENCES auth.users(id), accepted_at TIMESTAMPTZ, created_at TIMESTAMPTZ DEFAULT NOW()); ALTER TABLE user_invites ENABLE ROW LEVEL SECURITY; CREATE POLICY "Authenticated users can view invites" ON user_invites FOR SELECT TO authenticated USING (true); CREATE POLICY "Authenticated users can insert invites" ON user_invites FOR INSERT TO authenticated WITH CHECK (true); CREATE POLICY "Authenticated users can update invites" ON user_invites FOR UPDATE TO authenticated USING (true); CREATE POLICY "Authenticated users can delete invites" ON user_invites FOR DELETE TO authenticated USING (true);`
      const { error: createErr } = await supabase.rpc('exec_sql', { query: USER_INVITES_SQL }).maybeSingle()
      if (createErr) {
        console.log('user_invites table creation note:', createErr.message)
      } else {
        console.log('Created user_invites table')
      }
    }
  } catch (e) {
    console.log('Migration check:', e.message)
  }
}

export async function ensureSystemTables() {
  await runMigrations()
}
